import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Newspaper } from 'lucide-react';
import { ARTICLES } from '../stories/articles';

export default function Stories() {
  return (
    <section id="stories" className="bg-ink-50 border-y border-ink-200">
      <div className="container-page py-20 lg:py-28">
        <div className="max-w-3xl">
          <p className="eyebrow">Stories</p>
          <h2 className="mt-3 h-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight text-balance">
            News and perspective from the freight frontline.
          </h2>
          <p className="mt-5 text-lg text-ink-600 text-balance">
            How the industry is changing — and how Mariner and Vibe are building
            the standards that keep your freight moving and your business
            protected.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {ARTICLES.map((article) => (
            <Link
              key={article.slug}
              to={`/stories/${article.slug}`}
              className="group card-hover flex flex-col p-7 sm:p-8"
            >
              <div className="flex items-center gap-2 text-xs uppercase tracking-wider font-semibold text-ink-500">
                <Newspaper className="h-4 w-4" />
                {article.kicker}
                <span aria-hidden="true" className="text-ink-300">·</span>
                <span className="text-ink-400 normal-case tracking-normal font-medium">
                  {article.date}
                </span>
              </div>

              <h3 className="mt-4 h-display text-xl sm:text-2xl font-bold leading-snug text-balance">
                {article.title}
              </h3>

              <p className="mt-3 text-ink-600 line-clamp-4">{article.excerpt}</p>

              <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-ink-900">
                Read the story
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
